// extracted by mini-css-extract-plugin
export default {"scrollPrompt":"aMFxo8WY78xhZ7MhixDi","scrollPromptDisplay":"OCLXohDAOkiu_Bb8ASvj"};